"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedthunderstorm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedthunderstorm` : '') + (description ? ` desc-brandedthunderstorm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedthunderstorm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedthunderstorm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M41.09 24.42h8.8l-8.8 14.04H49L31.4 56l6.16-14.04h-5.28l8.8-17.54Z",
    fill: "#F7B941"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.56 40.73a3.04 3.04 0 0 1-4.13 1.5A3.3 3.3 0 0 1 6.95 38c.72-1.62 6.73-7.44 6.73-7.44s-.4 8.55-1.11 10.17h-.01Z",
    fill: "#8AE6EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M26.74 44.24a3.04 3.04 0 0 1-4.13 1.5 3.3 3.3 0 0 1-1.48-4.23c.72-1.62 6.73-7.44 6.73-7.44s-.39 8.54-1.11 10.17Z",
    fill: "#8AE6EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.89 53.17a3.04 3.04 0 0 1-4.14 1.5 3.3 3.3 0 0 1-1.48-4.23C10 48.82 16 43 16 43s-.39 8.55-1.1 10.17h-.01Z",
    fill: "#8AE6EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M56 16.97c0-4.37-3.1-8-7.16-8.78A13.13 13.13 0 0 0 36.74 0C32 0 27.87 2.57 25.56 6.41a9.86 9.86 0 0 0-5.87-1.94c-4.59 0-8.45 3.13-9.66 7.42C4.95 10.6 0 14.07 0 18.76c0 4.69 4.84 8.13 9.93 6.89a7.83 7.83 0 0 0 6.7 3.82 7.8 7.8 0 0 0 6.1-2.95A13.96 13.96 0 0 0 35 33.94c5.3 0 10.31-3.3 12.58-8.05A8.84 8.84 0 0 0 56 16.98v-.01Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M47.58 25.88A8.69 8.69 0 0 0 56 17.2v-.1c0-4.41-3.08-8.18-7.15-8.95a13.2 13.2 0 0 0-4.92-5.96A106.24 106.24 0 0 1 12.5 28.28a6.91 6.91 0 0 0 4 1.24 8.04 8.04 0 0 0 6.22-3A13.94 13.94 0 0 0 35 34c5.29 0 10.3-3.32 12.58-8.12Z",
    fill: "#C0C0C0"
  }));
};
var _default = exports.default = brandedthunderstorm;